import hotel from "./hotel.vue";

export default [
  {
    name: "admin-hotel",
    path: "/admin/hotel",
    component: hotel,
  },
];
